import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { BankruptcyForm } from './BankruptcyForm';
import Notification, { notify } from '../../common/Notification/Notification';

storiesOf('Fillings/LocalCourtSearch/Forms/Bankruptcy', module)
  .add('View', () => (
   <BankruptcyForm
      onSubmit={action('searchBankruptcy')}
      onClickSearchReset={action('resetLocalSearch')}
    />
  ))
  .add('Search error', () => (
    <div>
      <Notification/>
      <BankruptcyForm
        onSubmit={(...args) => {
          notify.error('Failed to search Bankruptcy Local Court');
          action('searchAppellate')(...args);
        }}
        onClickSearchReset={action('resetLocalSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/BankruptcyForm.stories.jsx